export const ListOfTestCarousel = [
    { span: 5, height: "27px" },
    { span: 1, height: "48px", classes: "marginTop-16" },
    { span: 4, height: "39px", classes: "marginTop-8" },
    { span: 4, height: "27px", classes: "marginTop-8" },
    { span: 4, height: "36px", classes: "marginTop-8" },
]

export const ListOfTestCarouselLabDetails = [
    { span: 14, height: "30px", classes: "marginTop-24" },
    { span: 14, height: "18px", classes: "marginTop-16" },
    {
        classes: "marginTop-16",
        columns: [
            {
                height: "300px",
                span: 5,
                rows: [
                    { span: 5, height: "158px" },
                    { span: 5, classes: "marginTop-4", height: "36px" },
                    { span: 3, classes: "marginTop-4", height: "18px" },
                    { span: 4, classes: "marginTop-4", height: "50px" },
                    { span: 2, classes: "marginTop-4", height: "18px" },
                    { span: 5, classes: "marginTop-4", height: "50px" },
                ],
            },
            {
                height: "300px",
                span: 5,
                rows: [
                    { span: 5, height: "158px" },
                    { span: 5, classes: "marginTop-4", height: "36px" },
                    { span: 3, classes: "marginTop-4", height: "18px" },
                    { span: 4, classes: "marginTop-4", height: "50px" },
                    { span: 2, classes: "marginTop-4", height: "18px" },
                    { span: 5, classes: "marginTop-4", height: "50px" },
                ],
            },
            {
                height: "300px",
                span: 5,
                rows: [
                    { span: 4, height: "158px" },
                    { span: 4, classes: "marginTop-4", height: "36px" },
                    { span: 3, classes: "marginTop-4", height: "18px" },
                    { span: 4, classes: "marginTop-4", height: "50px" },
                    { span: 2, classes: "marginTop-4", height: "18px" },
                    { span: 4, classes: "marginTop-4", height: "50px" },
                ],
            },
        ],
    },
    { span: 14, height: "36px", classes: "marginTop-16" },
]
